/** 充值缴费界面 */
<template>
  <div>
    <div class="user-info">
      <img :src="require('@assets/ic_user_portrait.png')" alt="" />
      <div>
        <div class="user-info-name">
          {{ userInfo.patientName }}
        </div>
        <div class="user-info-card-no">
          {{ userInfo.cardType === "2" ? "住院号" : "卡号" }}
          {{ userInfo.cardNo }}
        </div>
      </div>
      <div class="card-type">
        {{ getCardType }}
      </div>
    </div>
    <div class="hospital-info">
      <div>
        <span>医院</span>
        <span>龙岩人民医院</span>
      </div>
      <div>
        <span>预交金余额</span>
        <span>￥{{ userInfo.prepay }}</span>
      </div>
    </div>
    <div class="input-view">
      <span>充值金额</span>
      <van-field
        v-model="rechargeValue"
        type="number"
        placeholder="请输入金额"
        label="￥"
        label-width="1.5rem"
      />
    </div>
    <ph-button
      @click="onClick"
      :disabel="clickEnable === 'true' ? true : false"
      title="确认充值"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPops: false,
      userInfo: {},
      balance: "0",
      btnStyle: {
        backgroundImage: `url(${require("@assets/btn_confirm.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%"
      },
      ftype: "1",
      qrtype: "1",
      rechargeValue: "",
      orderNo: "",
      clickEnable: true
    };
  },
  computed: {
    getCardType() {
      let cardType = "";
      if (this.userInfo.cardType === "0") {
        cardType = "就诊卡";
      } else if (this.userInfo.cardType === "1") {
        cardType = "社保卡";
      } else if (this.userInfo.cardType === "2") {
        cardType = "住院号";
      }
      return cardType;
    }
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    this.qrtype = this.$route.query.qrtype || "1";
    this.$http
      .post(this.$api.USER_BASE_INFO, {
        functionType: this.ftype,
        eleFlag: this.qrtype === "2" ? "1" : "0"
      })
      .then(res => {
        this.userInfo = res;
      });
  },
  methods: {
    getOrderFormNo() {
      var type = this.ftype == "1" ? "1" : "2";
      // this.$http
      //   .post(this.$api.GET_ORDER_FORMNO, {
      //     payPlatform: "WeChatPay_GZH",
      //     money: this.rechargeValue,
      //     tradeType: this.ftype
      //   })
      //   .then(res => {
      //     this.orderNo = res.orderFormNo;
      //     window.location.href =
      //       "http://pay.fjlyrmyy.com/ylzUP/H5weixinpay/zsyypay?p_id=1&p_name=" +
      //       this.userInfo.patientName +
      //       "&WIDsubject=预交金&id_card=&card_no=" +
      //       this.userInfo.cardNo +
      //       "&card_type=3&account_type=" +
      //       type +
      //       "&system_id=" +
      //       res.orderFormNo +
      //       "&userid=2000&amount=" +
      //       this.rechargeValue +
      //       "&operator_id=5016&operator_name=公众号";
      //   });
      this.clickEnable = false;
      window.location.href =
        "http://app.fjlyrmyy.com/route/pay/rest/topup/payredirect?functionType=" +
        type +
        "&payPlatform=WeChatPay_GZH&money=" +
        this.rechargeValue +
        "&token=" +
        localStorage.getItem("token");
    },
    onClick() {
      if (!this.rechargeValue) {
        this.$toast("请输入金额");
        return;
      }
      this.getOrderFormNo();
      // var that = this;
      // this.$http
      //   .post(this.$api.RECHARGE_PAYMENT_COMMIT, {
      //     functionType: this.ftype,
      //     payPlatform: "WeChatPay_GZH",
      //     money: this.rechargeValue,
      //     eleFlag: this.qrtype === "2" ? "1" : "0"
      //   })
      //   .then(res => {
      //     /* eslint-disable no-undef */
      //     WeixinJSBridge.invoke(
      //       "getBrandWCPayRequest",
      //       JSON.parse(res.payParam),
      //       result => {
      //         if (result.err_msg == "get_brand_wcpay_request:ok") {
      //           that.$toast("充值成功");
      //           that.$router.replace({
      //             name: "recharge-record",
      //             query: {
      //               ftype: thas.ftype
      //             }
      //           });
      //         }
      //       }
      //     );
      //   });
    }
  }
};
</script>

<style lang="less" scoped>
.user-info {
  display: flex;
  align-items: center;
  margin: 1rem 0.94rem 0 0.94rem;
  padding: 1rem 0.94rem;
  color: white;
  background: #108eee;
  border-radius: 0.5rem 0.5rem 0 0;
  img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.81rem;
    background: white;
    border-radius: 50%;
  }
}

.card-type {
  margin-right: 1rem;
  margin-left: auto;
  padding: 0.25rem;
  font-size: 0.81rem;
  border: solid 0.03rem #fff;
  border-radius: 0.25rem;
}

.hospital-info {
  margin: 0 0.94rem 2rem 0.94rem;
  padding: 1rem 0.94rem;
  border: solid 0.06rem #ddd;
  border-radius: 0 0 0.5rem 0.5rem;

  > div {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    line-height: 1.8rem;
  }
}

.input-view {
  margin: 1rem 0.94rem;
  border-bottom: 1px solid #f4f4f4;

  .van-cell {
    align-items: center;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2.5rem;
  }
}

.pay-btn {
  width: calc(100% - 2rem);
  height: 2.94rem;
  margin: 1rem;
  background-color: #108eee;
  border: none;
  border-radius: 0.31rem;
}

.user-info-name {
  font-weight: 500;
  font-size: 1.06rem;
}
.user-info-card-no {
  font-size: 0.81rem;
  opacity: 0.8;
}
</style>
